import core from "./core.helper";
import file from "./file.helper";
import Gen from "./Gen.helper";
import screen from "./screen.helper";
import storage from "./storage.helper";

// const modules = require.context(".", false, /\.helper\.js$/)


const helpers = [
    core,
    file,
    Gen,
    screen,
    storage
];
function loadHelpers(app) {
    let apis = {};
    helpers.forEach(helper => {
        if (typeof helper === "function") helper = helper(app);
        apis = Object.assign(apis, helper);
    });
    app.helper = apis;
}

export default {
    loadHelpers
}

